var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgExternalLink = function SvgExternalLink(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 16,
    width: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.9 6.5a3.6 3.6 0 0 1 3.6-3.6.4.4 0 0 0 0-.8 4.4 4.4 0 0 0-4.4 4.4v1.588c0 1.312 0 2.064.19 2.69a4.4 4.4 0 0 0 2.933 2.933c.625.19 1.377.19 2.69.19H9.5a4.4 4.4 0 0 0 4.4-4.4h-.8a3.6 3.6 0 0 1-3.6 3.6H8c-1.425 0-2.048-.005-2.545-.156a3.6 3.6 0 0 1-2.4-2.4C2.905 10.048 2.9 9.425 2.9 8V6.5Zm6.7-4c0-.22.18-.4.4-.4h3.5c.221 0 .4.18.4.4V6a.4.4 0 0 1-.8 0V3.466L8.783 7.783a.4.4 0 0 1-.566-.566L12.534 2.9H10a.4.4 0 0 1-.4-.4Z",
    fill: "currentColor"
  })));
};
export default SvgExternalLink;